import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { logout } from "./store/redux/actions/userActionCreator";

// Lands here after the backend completes the OIDC end-session redirect.
// By now signoutRedirect() has already called removeUser() on the client,
// which fires addUserUnloaded → authLifecycle dispatches LOGOUT → root
// reducer resets state. This component runs the cleanup thunk as a safety
// net (purges persist:root explicitly, handles the race where redux-persist
// re-wrote post-LOGOUT initial state during navigation) and then navigates
// back to the landing page.
const LogoutCallback = ({ t, ...props }: any) => {
    const navigate = useNavigate();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        (async () => {
            try {
                await props.logout();
            } catch (e) {
                console.error("logout cleanup failed:", e);
            } finally {
                navigate("/", { replace: true });
            }
        })();
    }, []);

    return <p>{t('Signing out...')}</p>;
};

const mapStateToProps = (_state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
    logout: () => dispatch(logout()),
});

export default (connect(mapStateToProps, mapDispatchToProps))(withTranslation()(LogoutCallback));
